import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Layer: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      fill: 'none',
      width: '32px',
      height: '32px',
      ...sx,
    }}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 9.36533L15.9827 14.732L28 9.36533L16.0173 4L4 9.36533Z"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5813 19.3125L28 22.6352L15.9827 28.0005L4 22.6352L11.4187 19.3218"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5813 12.6777L28 15.9991L15.9827 21.3644L4 15.9991L11.4187 12.6871"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
